export default "__VITE_ASSET__BqmoVaHl__"